import { FormattedMessage, useIntl } from 'react-intl';
import { type TabProps } from '@m/alchemy-ui/Tab';
import { type IActivity } from '../../../../../common/interfaces';
import { TabbedPanel } from '../TabbedPanel/TabbedPanel';
import { Alert, List } from '../common/styles';
import { ActivityItem } from './ActivityItem';

interface IActivityProps {
  data: IActivity[];
  panelSize: number;
  hasWideSibling: boolean;
  mobilePreviewMode?: boolean;
}

export const Activity = ({ data, panelSize, hasWideSibling, mobilePreviewMode = false }: IActivityProps) => {
  const intl = useIntl();

  const activities = data?.map((activity) => (
    <ActivityItem
      key={activity.event.id}
      data={activity}
      panelSize={panelSize}
      hasWideSibling={hasWideSibling}
      mobilePreviewMode={mobilePreviewMode}
    />
  ));
  const tabs = [
    {
      label: intl.formatMessage({ id: 'activity', defaultMessage: 'Activity' }),
      value: 'activity',
      layout: 'left',
      isActive: true
    } as TabProps
  ];
  const noActivitiesMessage = (
    <FormattedMessage id="page.thereIsNoActivityToShowYet." defaultMessage="There is no activity to show yet." />
  );

  const composedTabViewData = () =>
    activities?.length === 0 ? (
      <Alert>{noActivitiesMessage}</Alert>
    ) : (
      <>
        <List $mobilePreviewMode={mobilePreviewMode}>{activities}</List>
      </>
    );

  return (
    <div data-testid="activity-tab-panel">
      <TabbedPanel tabs={tabs} content={composedTabViewData()} defaultActiveTab="activity" />
    </div>
  );
};
